import API from "@core/api/api";

export const fetchAllCities = async (search = "", limit = 20, page = 1) => {
  let params = new URLSearchParams();

  if (search) {
    params.append("search", search);
  }
  params.append("limit", limit.toString());
  params.append("page", page.toString());

  const response = await API.get(`/citys?${params.toString()}`);
  return response.data;
};

export const fetchCityByID = async ({ cityId }) => {
  const response = await API.get(`/citys/${cityId}`);
  return response.data;
};

export const fetchCityByName = async (cityName) => {
  const response = await API.get(`/citys?search=${cityName}&limit=1`);
  // Return the first city that matches exactly
  const cities = response.data.cities || [];
  return cities.find(city => 
    city.name.toLowerCase() === cityName.toLowerCase()
  ) || null;
};

export const createCity = async (city) => {
  const response = await API.post(`/citys`, city);
  return response.data;
};

export const deleteCity = async (cityId) => {
  const response = await API.delete(`/citys/${cityId}`);
  return response.data;
};

export const bulkDeleteCities = async (cityIds) => {
  const response = await API.post(`/citys/bulk-delete`, { ids: cityIds });
  return response.data;
};

export const updateCity = async ({ id, city }) => {
  const response = await API.put(`/citys/${id}`, city);
  return response.data;
};

export const exportCities = async () => {
  const response = await API.get("/citys");
  const cities = response.data;

  // Convert to CSV format
  const csvContent = [
    [
      "Name",
      "Arabic Name",
      "Deadline",
      "Delivery Fees",
      "Refusal Fees",
      "Cancellation Fees",
      "Fixed Fees",
      "Hub",
      "Zone",
      "Delai de Livraison",
      "Jour",
      "Ville",
      "Sortie par Semaine",
    ],
    ...cities.map((city) => [
      city.name,
      city.nameArabic,
      city.deadline,
      city.deliveryFees,
      city.refusalFees,
      city.cancellationFees,
      city.isFeesFixed ? "Yes" : "No",
      city.hub || "",
      city.zone || "",
      city.delai_de_livraison || "",
      city.jour || "",
      city.ville || "",
      city.sortie_par_semaine || "",
    ]),
  ];

  return csvContent.map((row) => row.join(",")).join("\n");
};
